import { string, bool } from 'prop-types';
import React from 'react';
import BsImages from '../icons/BsImages';
import { Link } from 'react-router-dom';
import ResponsiveImage from './ResponsiveImage';
import useSearch from '../hooks/useSearch';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';

export default function CollectionListItem({ title, imageUrl, handle, showImage }) {
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const { searchQuery } = useSearch();
    const urlParams = new URLSearchParams();
    Object.entries(searchQuery).forEach(([key, value]) => {
        urlParams.append(key, value);
    });

    return (<li
        className={'collection-list--item'}
        style={{
            ...showImage === false && ({ aspectRatio: 'initial' }),
        }}>
        <Link
            to={`${collectionPath[0].pathBeforeParams}/${handle}?${urlParams.toString()}`}>
            {(showImage === true && imageUrl) && (<div
                className={'collection-list-item--image'}><ResponsiveImage
                    imageUrl={imageUrl}
                    imageAlt={title || ''}
                    mobileSize={'200px'}
                    desktopSize={'200px'}></ResponsiveImage></div>)}
            {(showImage === true && !imageUrl) && (<div
                className={'collection-list-item--image'}>
                <BsImages
                    style={{ maxWidth: '150px' }} />
            </div>)}
            <span
                className={'collection-list-item--title'}>{title}</span>
        </Link>
    </li>);
}

CollectionListItem.propTypes = {
    title: string,
    imageUrl: string,
    handle: string,
    showImage: bool,
};